import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_logged/onboarding/$club/")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Navigate to="/onboarding/$club/theme" from={Route.fullPath} />;
}
